module.exports = require('./helpers/bundle-url').getBundleURL('89Ico') + "logo-dark.eefe0b7f.svg";